<template>
  <div>
    <title-bar title="硬件协议版本">
      <el-button type="default" icon="fa fa-refresh" @click="reloadCache" :loading="loading">刷新缓存</el-button>
      <el-button type="primary" icon="fa fa-plus" @click="edit()" :loading="loading">新增版本</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="版本编码">
          <el-input v-model="queryForm.versionCode" clearable placeholder="如 04000501" @keyup.enter.native="query"></el-input>
        </el-form-item>
        <el-form-item label="版本名称">
          <el-input v-model="queryForm.versionName" clearable placeholder="模糊查询" @keyup.enter.native="query"></el-input>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
        <el-button type="default" @click="resetQuery">重置</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="versionCode" label="版本编码" min-width="120"></el-table-column>
        <el-table-column prop="versionName" label="版本名称" min-width="180"></el-table-column>
        <el-table-column prop="inputOffset" label="输入偏移" width="90" align="center"></el-table-column>
        <el-table-column prop="holdingOffset" label="保持偏移" width="90" align="center"></el-table-column>
        <el-table-column prop="inputCount" label="输入寄存器" width="100" align="center"></el-table-column>
        <el-table-column prop="holdingCount" label="保持寄存器" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="action" label="操作" width="180" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="openCopy(row)">复制</el-button>
            <el-button type="text" class="color-error" @click="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>

    <el-dialog title="复制协议版本" :visible.sync="copyVisible" width="520px" :close-on-click-modal="false">
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 16px"
        :title="'将基于「' + (copySource ? copySource.versionCode + ' ' + copySource.versionName : '') + '」复制配置'"
      ></el-alert>
      <el-form ref="copyForm" :model="copyForm" :rules="copyRules" label-width="110px">
        <el-form-item label="新版本编码" prop="versionCode">
          <el-input v-model="copyForm.versionCode" placeholder="如 04000502"></el-input>
        </el-form-item>
        <el-form-item label="新版本名称" prop="versionName">
          <el-input v-model="copyForm.versionName" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="复制内容">
          <el-checkbox v-model="copyForm.copyInput">输入寄存器映射</el-checkbox>
          <el-checkbox v-model="copyForm.copyHolding">保持寄存器参数</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="copyVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="confirmCopy">确定复制</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";

export default {
  name: "HwProtocolVersionList",
  components: { TablePagination, TitleBar },
  extends: BaseVue,
  data() {
    return {
      queryForm: {
        versionCode: "",
        versionName: "",
        page: 1,
        limit: 10
      },
      records: [],
      total: 0,
      copyVisible: false,
      copySource: null,
      copyForm: {
        versionCode: "",
        versionName: "",
        copyInput: true,
        copyHolding: true
      },
      copyRules: {
        versionCode: [{ required: true, message: "请输入新版本编码", trigger: "blur" }],
        versionName: [{ required: true, message: "请输入新版本名称", trigger: "blur" }]
      }
    };
  },
  created() {
    const cache = this.getComponentCache && this.getComponentCache();
    if (cache) {
      this.queryForm = Object.assign({}, this.queryForm, cache);
    }
    if (this.clearComponentCache) {
      this.clearComponentCache();
    }
    this.loadData();
  },
  methods: {
    query() {
      this.queryForm.page = 1;
      this.loadData();
    },
    resetQuery() {
      this.queryForm.versionCode = "";
      this.queryForm.versionName = "";
      this.query();
    },
    loadData() {
      this.loading = true;
      this.postForm("/hw-protocol/page", this.queryForm, true)
        .then(dr => {
          this.records = dr.rows || [];
          this.total = dr.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(row) {
      if (this.saveCache) {
        this.saveCache();
      }
      if (row && row.id) {
        this.$router.push({ path: "/hwProtocolVersionEdit", query: { id: row.id } });
      } else {
        this.$router.push({ path: "/hwProtocolVersionEdit" });
      }
    },
    openCopy(row) {
      this.copySource = row;
      this.copyForm = {
        versionCode: "",
        versionName: row.versionName + "-副本",
        copyInput: true,
        copyHolding: true
      };
      this.copyVisible = true;
    },
    confirmCopy() {
      this.$refs.copyForm.validate(yes => {
        if (!yes) {
          return;
        }
        this.loading = true;
        this.postJson("/hw-protocol/copy", {
          sourceId: this.copySource.id,
          versionCode: this.copyForm.versionCode,
          versionName: this.copyForm.versionName,
          copyInput: this.copyForm.copyInput,
          copyHolding: this.copyForm.copyHolding
        }, true)
          .then(dr => {
            this.copyVisible = false;
            const bean = dr.bean || {};
            this.$router.push({
              path: "/hwProtocolVersionEdit",
              query: { id: bean.id }
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    del(row) {
      this.$confirm("确定要删除该版本吗？删除后不可恢复。", "系统提示").then(() => {
        this.loading = true;
        this.postForm("/hw-protocol/delete", { id: row.id }, true)
          .then(() => {
            this.loadData();
          })
          .finally(() => {
            this.loading = false;
          });
      }).catch(() => {});
    },
    reloadCache() {
      this.loading = true;
      this.postForm("/hw-protocol/reload-cache", null, true)
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>
